<template>
  <component :is="layout">
    <router-view />
  </component>
  <div v-if="isLoading" class="loading-spinner d-flex justify-content-center align-items-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <MainFooter/>
</template>

<script>
import { computed, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import LoginLayout from './layouts/LoginLayout.vue';
import MainLayout from './layouts/MainLayout.vue';
import MainFrontLayout from './layouts/MainFrontLayout.vue';
import RegisterLayout from './layouts/RegisterLayout.vue';
import loadingStore from './loading'; // Make sure this path is correct
import MainFooter from './layouts/MainFooter.vue';

// Google Analytics Subdomain Mapping
const subdomainMap = {
  'neaionia.eea.gr': 'G-1PK2LBCN2V',
  'papagou-cholargou.eea.gr': 'G-J8D3FZKB54',
  'neafiladelfeia.eea.gr': 'G-0JLCKQVWHE',
  'ilioupoli.eea.gr': 'G-9X0RGJ8MPD',
  'mycitymarket.eea.gr': 'G-ZP52JJBRZQ'
};

export default {
  name: 'App',
  components: {
    LoginLayout,
    MainLayout,
    RegisterLayout,
    MainFrontLayout,
    MainFooter
  },
  setup() {
    const isLoading = computed(() => loadingStore.isLoading.value);
    const route = useRoute();
    const layout = computed(() => route.meta.layout || 'MainLayout');

    // Get subdomain and determine tracking ID
    const hostname = window.location.hostname;
    const trackingId = subdomainMap[hostname] || 'G-ZP52JJBRZQ'; // Default GA ID

    // Function to load Google Analytics script
    const loadGoogleAnalytics = () => {
      if (!trackingId) return;

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', trackingId);
    };

    // Initialize GA when component mounts
    onMounted(() => {
      loadGoogleAnalytics();
    });

    // Track page views with hostname
    watch(route, (to) => {
      if (window.gtag) {
        const hostname = window.location.hostname;
        const cleanPath = to.fullPath.startsWith('/') ? to.fullPath.substring(1) : to.fullPath; // Remove leading /
        
        window.gtag('event', 'page_view', {
          page_path: `${hostname}/${cleanPath}`, // Ensures format "subdomain.domain.gr/path"
          page_location: window.location.href,
          page_hostname: hostname,
          page_title: document.title
        });
      }
  });
    
    return { layout, isLoading };
  }
};
</script>

<style>
  @font-face {
    font-family: 'cera';
    src: url('@/assets/fonts/cera/cera.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  * {
    font-family: 'cera', sans-serif;
  }
  .loading-spinner {
    position: fixed;
    top: 12%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    margin-top: 200px; /* Adjust this value to move the spinner down */
  }

  .spinner-border {
    width: 3rem;
    height: 3rem;
  }
  .swiper-button-prev, .swiper-button-next{
    border: 2px solid #0C4C73 !important;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    color: #0C4C73;
  }
  .swiper-button-prev:hover, .swiper-button-next:hover{
    transform: scale(1.1);
    transition: 1s;
    background: #0C4C73;
    color: #fff;
  }
  .swiper-button-next:after, .swiper-button-prev:after{
    font-size: 20px;
    font-weight: bold;
    text-shadow: -1px 0px #0C4C73;
  }
  .swiper-pagination-bullet {
    width: 20px;
    height: 20px;
    border: 2px solid #0C4C73;
    opacity: 1;
    background: #ffffff
  }
  .swiper-pagination-bullet-active{
    background: #0C4C73;
  }
  .swiper-pagination{
    position: relative;
  }
  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }
</style>
